import styled, { css } from "styled-components";
import { type SpaceProps, type PositionProps, type WidthProps, space, position, width } from "styled-system";
import { type ColorType, type IconSizeType, theme } from "../theme/toyotaTheme";

export const IconWrapper = styled.span<{ iconColor?: ColorType; size?: IconSizeType } & SpaceProps & WidthProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ iconColor }) => iconColor && theme.colors[iconColor]};
    ${space};
    ${width};

    .icon {
        padding: 0;
        ${({ size }) =>
            size &&
            css`
                line-height: 1;
                &::before {
                    font-size: ${theme.iconSize[size]} !important;
                }
            `}
    }

    img {
        max-width: 100%;
    }
`;

export const SvgWrapper = styled.span<SpaceProps>`
    display: flex;
    align-items: center;
    line-height: 2rem; /* Should be same height as default icon-size => 20px */
    ${space};
`;

export const UspIconWrapper = styled.div<{ size?: number; iconColor?: ColorType }>`
    line-height: 1;
    color: ${({ iconColor }) => iconColor && theme.colors[iconColor]};
    ${({ size }) =>
        size &&
        css`
            .usp-icon {
                width: ${size}px;
                height: ${size}px;
                &::before {
                    top: 1px;
                    left: 0;
                    width: ${size}px;
                    height: ${size}px;
                    font-size: ${size}px;
                }
            }
        `}
`;

export const ToggleIconWrapper = styled.span<
    { iconColor?: ColorType; isDown: boolean; size?: IconSizeType } & SpaceProps & PositionProps
>`
    display: flex;
    position: relative;
    align-items: center;
    width: 24px;
    height: 24px;
    ${space};

    ${({ iconColor }) =>
        iconColor &&
        `
        color: ${theme.colors[iconColor]};
    `};

    svg,
    .icon,
    .dxp-icon {
        transform: ${(props) => (props.isDown ? "rotate(180deg)" : "none")};
        transition:
            transform 0.3s,
            color 0.3s;
        ${position};

        ${({ size }) =>
            !!size &&
            css`
                line-height: 1;
                &::before {
                    font-size: ${theme.iconSize[size]} !important;
                }
            `};
    }
`;

export default IconWrapper;
